import {
  GetSimulationSupplierAllocationRes,
  GetSimulationSupplierAllocationReq
} from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

/** 労務山積計算-業者配分結果取得 */
export class GetSupplierAllocationGateway {
  static getSimulationSupplierAllocation = async (
    params: GetSimulationSupplierAllocationReq
  ) => {
    return await yamadumiApi.get<
    GetSimulationSupplierAllocationRes
    >('/api/simulation/supplier-allocation', { ...params })
  }
}
